/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
// import React, { useState } from "react";
// import { Table } from "antd";

// const Datatable = ({
//   props,
//   columns,
//   dataSource,
//   bordered = false,
//   stickyHeader = false,
// }) => {
//   const [searchText, setSearchText] = useState("");
//   const [selectedRowKeys, setSelectedRowKeys] = useState([]);
//   const [filteredDataSource, setFilteredDataSource] = useState(dataSource);
//   const onSelectChange = (newSelectedRowKeys) => {
//     setSelectedRowKeys(newSelectedRowKeys);
//   };

//   const handleSearch = (value) => {
//     setSearchText(value);
//     const filteredData = dataSource.filter((record) =>
//       Object.values(record).some((field) =>
//         String(field).toLowerCase().includes(value.toLowerCase())
//       )
//     );
//     setFilteredDataSource(filteredData);
//   };
//   const rowSelection = {
//     selectedRowKeys,
//     onChange: onSelectChange,
//   };

//   return (
//     <>
//       <div className="search-set table-search-set">
//         <div className="search-input">
//           <a href="#" className="btn btn-searchset">
//             <i className="ti ti-search fs-14 feather-search" />
//           </a>
//           <div id="DataTables_Table_0_filter" className="dataTables_filter">
//             <label>
//               {" "}
//               <input
//                 type="search"
//                 onChange={(e) => handleSearch(e.target.value)}
//                 className="form-control form-control-sm"
//                 placeholder="Search"
//                 aria-controls="DataTables_Table_0"
//               />
//             </label>
//           </div>
//         </div>
//       </div>

//       <Table
//         key={props}
//         className="table datanew dataTable no-footer"
//         // rowSelection={rowSelection}
//         columns={columns}
//         dataSource={filteredDataSource}
//         rowKey={(record) => record.id}
//         bordered={bordered}
//         scroll={{
//           x: "max-content",
//           ...(stickyHeader && { y: 500 }), // 👈 only add vertical scroll if stickyHeader is true
//         }}
//         pagination={{
//           locale: { items_per_page: "" },
//           nextIcon: (
//             <span>
//               <i className="fa fa-angle-right" />
//             </span>
//           ),
//           prevIcon: (
//             <span>
//               <i className="fa fa-angle-left" />
//             </span>
//           ),
//           defaultPageSize: 100,
//           showSizeChanger: true,
//           pageSizeOptions: ["100", "200", "300"],
//         }}
//       />
//     </>
//   );
// };

// export default Datatable;

/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Table } from "antd";

const Datatable = ({
  props,
  columns,
  dataSource,
  bordered = false,
  stickyHeader = false,
  showSlno = true, // 🔥 NEW PROP (Default true to show Sl.No)
}) => {
  const [searchText, setSearchText] = useState("");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [filteredDataSource, setFilteredDataSource] = useState(dataSource);

  // pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);

  const handleSearch = (value) => {
    setSearchText(value);
    const filteredData = dataSource.filter((record) =>
      Object.values(record).some((field) =>
        String(field).toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredDataSource(filteredData);
  };

  // inject sl.no column only if enabled
  const modifiedColumns = showSlno
    ? [
        {
          title: "Sl. No",
          key: "slno",
          width: 80,
          render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
        },
        ...columns,
      ]
    : columns;

  return (
    <>
      <div className="search-set table-search-set">
        <div className="search-input">
          <a href="#" className="btn btn-searchset">
            <i className="ti ti-search fs-14 feather-search" />
          </a>
          <div id="DataTables_Table_0_filter" className="dataTables_filter">
            <label>
              <input
                type="search"
                onChange={(e) => handleSearch(e.target.value)}
                className="form-control form-control-sm"
                placeholder="Search"
              />
            </label>
          </div>
        </div>
      </div>

      <Table
        key={props}
        className="table datanew dataTable no-footer"
        columns={modifiedColumns}
        dataSource={filteredDataSource}
        rowKey={(record) => record.id}
        bordered={bordered}
        scroll={{
          x: "max-content",
          ...(stickyHeader && { y: 500 }),
        }}
        pagination={{
          locale: { items_per_page: "" },
          defaultPageSize: 100,
          showSizeChanger: true,
          pageSizeOptions: ["100", "200", "300"],
          nextIcon: (
            <span>
              <i className="fa fa-angle-right" />
            </span>
          ),
          prevIcon: (
            <span>
              <i className="fa fa-angle-left" />
            </span>
          ),

          // 🔥 update serial number dynamically
          onChange: (page, size) => {
            setCurrentPage(page);
            setPageSize(size);
          },
        }}
      />
    </>
  );
};

export default Datatable;
